<template>
  <div class="row row-space-2">
    <!-- begin widget-chart -->
    <div
      class="widget widget-rounded m-b-30"
      v-bind:class="{ 'inverse-mode': inverseMode }"
    >
      <!-- begin widget-header -->
      <div class="widget-header">
        <h4 class="widget-header-title ts-flex ts-justify-between">
          <div
            class="ts-flex ts-justify-content-start"
            :class="{ 'ts-text-gray-700': !inverseMode }"
          >
            <strong>
              {{
                $t('dashboardcomponents.totalCampusAttendanceAndStudentPickup')
              }}</strong
            >
          </div>
          <div
            class="btn-group btn-group-justified ts-flex ts-justify-content-center"
          >
            <a
              class="btn btn-default"
              :class="{ 'btn-info': barChart }"
              @click.prevent="() => [(barChart = 'active'), (tableList = '')]"
            >
              Bar Chart
            </a>
            <a
              class="btn btn-default"
              :class="{ 'btn-info': tableList }"
              @click.prevent="() => [(barChart = ''), (tableList = 'active')]"
            >
              Table List
            </a>
          </div>
          <div class="ts-flex ts-justify-content-end ts-justify-item-center">
            <ts-branch-filter @filter="value => (branch_id = value)" />
            <a-range-picker
              style="width: 300px"
              v-model="rangeDate"
              :ranges="{
                Today: [moment(), moment()],
                'This Month': [
                  moment().startOf('month'),
                  moment().endOf('month')
                ]
              }"
              format="DD-MM-YYYY"
            />
          </div>
        </h4>
      </div>
      <!-- end widget-header -->
      <!-- begin vertical-box -->
      <ts-loading-banner :loading="loading">
        <div
          class="vertical-box with-grid with-border-top"
          v-if="barChart == 'active'"
        >
          <!-- begin vertical-box-column -->
          <div class="vertical-box-column p-4" style="width: 50%">
            <p>
              {{
                $t(
                  'dashboardcomponents.abarchartshowthestatisticsoftheTotalCampusAttendanceBasedontheselectedBranchAndAPeriodOfDate'
                )
              }}
            </p>
            <bar-chart
              :data="{
                labels: campusLabels,
                datasets: campusByScanDatasets
              }"
              :options="options"
              class="height-sm"
            ></bar-chart>
          </div>
          <!-- end vertical-box-column -->
          <!-- begin vertical-box-column -->
          <div class="vertical-box-column widget-chart-content">
            <div class="nv-stacked-area-chart height-full">
              <p>
                {{
                  $t(
                    'dashboardcomponents.abarchartshowthestatisticsoftheTotalStudentPickupBasedontheselectedBranchAndAPeriodOfDate'
                  )
                }}
              </p>
              <bar-chart
                :data="{
                  labels: studentPickupLabels,
                  datasets: studentPickupDatasets
                }"
                :options="options"
                class="height-sm"
              ></bar-chart>
            </div>
          </div>
          <!-- end vertical-box-column -->
        </div>
        <div
          class="vertical-box with-grid with-border-top"
          v-if="tableList == 'active'"
        >
          <!-- begin vertical-box-column -->
          <div class="vertical-box-column p-4" style="width: 50%">
            <p>
              Table list show the statistics of the total campus attendance based on the selected branch and a period of dates.
            </p>
            <div class="overflow-auto" style="max-height: 40vh;">
              <table width="100%" class="table ui-table ts-table">
                <thead>
                  <tr class="ts-sticky ts-top-0">
                    <th>Sub Program</th>
                    <th class="text-center">Number of Student</th>
                    <th class="text-center">Number of Transaction</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(records, branch_name) in campusByScanByBranch"
                  >
                    <tr style="background-color: #F9FBFB">
                      <td
                        style="padding: 11px 4px"
                        class="text-primary ts-font-bold"
                      >
                        Total: {{ branch_name }}
                      </td>
                      <td
                        style="padding: 11px 4px"
                        class="text-primary ts-font-bold text-center"
                      >
                        {{ numberFormat(calculateSum(records, 'num_student')) }}
                      </td>
                      <td
                        style="padding: 11px 4px"
                        class="text-primary ts-font-bold text-center"
                      >
                      {{ numberFormat(calculateSum(records, 'num_tran')) }}
                      </td>
                    </tr>
                    <tr v-for="(item, acps_name) in records">
                      <td>{{ acps_name }}</td>
                      <td class="text-center">
                        {{ numberFormat(item.num_student) }}
                      </td>
                      <td class="text-center">
                        {{ numberFormat(item.num_tran) }}
                      </td>
                    </tr>
                  </template>
                </tbody>
                <tfoot>
                  <tr style="background-color: #F9FBFB" class="ts-sticky ts-bottom-0">
                    <td class="text-success ts-font-bold">TOTAL: </td>
                    <td class="text-success ts-font-bold text-center">{{ numberFormat(grandTotal(campusByScanByBranch, 'num_student')) }}</td>
                    <td class="text-success ts-font-bold text-center">{{ numberFormat(grandTotal(campusByScanByBranch, 'num_tran')) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!-- end vertical-box-column -->
          <!-- begin vertical-box-column -->
          <div class="vertical-box-column widget-chart-content">
            <div class="nv-stacked-area-chart height-full">
              <p>
                Table list show the statistics of the total student pickup based on the selected branch and a period of dates.
              </p>
              <div class="overflow-auto" style="max-height: 40vh;">
              <table width="100%" class="table ui-table ts-table">
                <thead>
                  <tr class="ts-sticky ts-top-0">
                    <th>Sub Program</th>
                    <th class="text-center">Number of Student</th>
                    <th class="text-center">Number of Transaction</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(records, branch_name) in studentPickupByBranch"
                  >
                    <tr style="background-color: #F9FBFB">
                      <td
                        style="padding: 11px 4px"
                        class="text-primary ts-font-bold"
                      >
                        Total: {{ branch_name }}
                      </td>
                      <td
                        style="padding: 11px 4px"
                        class="text-primary ts-font-bold text-center"
                      >
                        {{ numberFormat(calculateSum(records, 'num_student')) }}
                      </td>
                      <td
                        style="padding: 11px 4px"
                        class="text-primary ts-font-bold text-center"
                      >
                      {{ numberFormat(calculateSum(records, 'num_tran')) }}
                      </td>
                    </tr>
                    <tr v-for="(item, acps_name) in records">
                      <td>{{ acps_name }}</td>
                      <td class="text-center">
                        {{ numberFormat(item.num_student) }}
                      </td>
                      <td class="text-center">
                        {{ numberFormat(item.num_tran) }}
                      </td>
                    </tr>
                  </template>
                </tbody>
                <tfoot>
                  <tr style="background-color: #F9FBFB" class="ts-sticky ts-bottom-0">
                    <td class="text-success ts-font-bold">TOTAL: </td>
                    <td class="text-success ts-font-bold text-center">{{ numberFormat(grandTotal(studentPickupByBranch, 'num_student')) }}</td>
                    <td class="text-success ts-font-bold text-center">{{ numberFormat(grandTotal(studentPickupByBranch, 'num_tran')) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            </div>
          </div>
          <!-- end vertical-box-column -->
        </div>
      </ts-loading-banner>
      <!-- end vertical-box -->
    </div>
    <!-- end widget-chart -->
  </div>
</template>
<script>
import BarChart from '@/components/vue-chartjs/BarChart'
import { map, keys, debounce } from 'lodash'
import moment from 'moment'
export default {
  components: {
    BarChart
  },
  props: ['inverseMode'],
  data() {
    return {
      barChart: 'active',
      tableList: '',
      rangeDate: [moment().add(-3, 'Month'), moment()],
      branch_id: [],
      loading: false,
      studentPickup: [],
      studentPickupByBranch: [],
      campusByScan: [],
      campusByScanByBranch: [],
      status: ['Number of Student', 'Number of Transaction'],
      borderColor: ['#00acac', '#49b6d6'],
      backgroundColor: ['rgba(0, 172, 172, 0.5)', 'rgba(73, 182, 214, 0.7)'],
      borderColor1: ['#117A65', '#21618C'],
      backgroundColor1: ['rgba(17, 122, 101, 0.7)', 'rgba(33, 97, 140, 0.7)'],
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  computed: {
    campusLabels() {
      return keys(this.campusByScan)
    },
    campusByScanDatasets() {
      return this.status.map((s, index) => {
        return {
          label: s,
          borderColor: this.borderColor[index],
          backgroundColor: this.backgroundColor[index],
          borderWidth: 1,
          data: map(this.campusByScan, r => {
            return r[s]
          })
        }
      })
    },
    studentPickupLabels() {
      return keys(this.studentPickup)
    },
    studentPickupDatasets() {
      return this.status.map((s, index) => {
        return {
          label: s,
          borderColor: this.borderColor1[index],
          backgroundColor: this.backgroundColor1[index],
          borderWidth: 1,
          data: map(this.studentPickup, r => {
            return r[s]
          })
        }
      })
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    moment,
    fetchData() {
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('dashboard/fetchCampusAndStudentPickup', {
          branch_id: this.branch_id,
          date_from: this.rangeDate[0].format('DD-MM-YYYY'),
          date_to: this.rangeDate[1].format('DD-MM-YYYY')
        })
        .then(responses => {
          this.studentPickup = responses.studentPickup
          this.studentPickupByBranch = responses.studentPickupByBranch
          this.campusByScan = responses.campus
          this.campusByScanByBranch = responses.campusByBranch
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    numberFormat(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    calculateSum(array, property) {
      let total = 0
      _.map(array, object => {
        total += object[property]
      })

      return total
    },
    grandTotal(array, property) {
      let total = 0
      _.map(array, subs => {
        _.map(subs, object => {
          total += object[property]
        })
      })

      return total
    }
  },
  watch: {
    rangeDate: function() {
      this.fetchData()
    },
    branch_id: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
<style scoped>
.ant-select-selection--multiple {
  height: auto;
  margin-bottom: 0px !important;
  margin-left: 5px;
}
.widget-header-title,
.widget-header-icon {
  padding: 5px 10px !important;
}
</style>
